import {
    MDBBreadcrumb,
    MDBBreadcrumbItem,
    MDBBtn,
    MDBCol,
    MDBRow,
    MDBScrollspy,
    MDBScrollspyLink,
    MDBSpinner,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { FormProvider, useForm } from "react-hook-form";
import { Tooltip } from "react-tooltip";
import EditWarning from "../components/header/EditWarning";
import TopSuccess from "../components/header/TopSuccess";
import TopMessage from "../components/header/TopMessage";
import SaveChanges from "../components/topviews/saveCancel";
import { getSpecificSharedVoicemail, updateSharedVoicemail } from "../apiclients/streamsapi_bridge";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import VMSettingsMain from "./VMSettingsMain";
import VMSettingsUsers from "./VMSettingsUsers";
import MainLinks from "../components/navlinks/MainLinks";
import Body from "../components/body/BodyPage";

function VMSettings() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [vmInfo, setVmInfo] = useState(location.state ? location.state : {});
    const [basicActive, setBasicActive] = useState("tab1");
    const [isloading, setIsloading] = useState(false);
    const [rerender, setRerender] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const { isEdited, setEdited } = useAdminContext();
    const [targetView, setTargetView] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const [vmPin, setvmPin] = useState("");
    const [extension, setextension] = useState(0);
    const [vmName, setvmName] = useState("");
    const [greetingsInfo, setGreetingsInfo] = useState({});
    const [assocCallFlows, setAssocCallFlows] = useState([]);

    const warningToggle = () => setShowWarning(!showWarning);

    const section1 = useRef(null);
    const containerRef = useRef(null);

    const methods = useForm({
        defaultValues: {
            name: "",
            extension: 0,
            vmail_pin: 0,
            play_msg_time_stmp: false,
            email_notify: true,
            email_address: "",
            inc_user_sup: true,
            vmail_delete: true,
            email_transcript: true,
            broadcast_vm_to_account: false,
            email_to_members: false,
            email_to_sup: false,
            vmlformat: 0,
        },
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isDirty, dirtyFields },
        setValue,
        watch,
        setError,
        clearErrors,
        getValues,
    } = methods;

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage("");
            }, 5000);
        }
    }, [successMessage]);

    async function getSpecificVMDetails() {
        try {
            setIsloading(true);
            const response = await getSpecificSharedVoicemail(JSON.parse(sessionStorage.getItem("admin_session")).siteid, vmInfo.vmid);
            setTimeout(() => {
                setIsloading(false);
            }, 1000);

            const vmDetails = await response.json();

            console.log("getSpecific VM Details ::: " + JSON.stringify(vmDetails));

            const vmSettings = vmDetails?.vm_settings ?? {};
            const greetings = vmSettings?.greetings ?? {};

            // Set greetings info
            setGreetingsInfo({
                busy: greetings?.busy ?? {},
                unavailable: greetings?.unavailable ?? {},
            });
            setextension(vmSettings?.extension ?? 0);
            setvmPin(vmSettings?.vmail_pin ?? "");
            setvmName(vmSettings?.name ?? "");
            setAssocCallFlows(vmSettings?.associated_callflows ?? []);

            // Reset form with fetched data
            reset({
                name: vmSettings?.name ?? "",
                extension: vmSettings?.extension ?? 0,
                vmail_pin: vmSettings?.vmail_pin ?? 0,
                play_msg_time_stmp: false,
                email_notify: vmSettings?.email_notify ?? true,
                email_address: vmSettings?.email_address ?? "",
                inc_user_sup: true,
                vmail_delete: vmSettings?.vmail_delete ?? true,
                email_transcript: vmSettings?.email_transcript ?? true,
                broadcast_vm_to_account: false,
                email_to_members: vmSettings?.email_to_members ?? false,
                email_to_sup: vmSettings?.email_to_sup ?? false,
                vmlformat: vmSettings?.vmlformat !== undefined ? vmSettings?.vmlformat : 0,
            });

            setRerender(false);
        } catch (error) {
            console.error("Error fetching VM details:", error);
            setIsloading(false);
        }
    }

    useEffect(() => {
        if ((vmInfo.vmid || rerender) && basicActive === "tab1") {
            getSpecificVMDetails();
            setRerender(false);
        }
    }, [vmInfo.vmid, rerender, basicActive]);

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        } else if (isEdited) {
            setTargetView(value);
            setShowWarning(true);
            return;
        }

        setBasicActive(value);
    };

    const handleOk = () => {
        setEdited(false);
        reset();
        if (targetView.indexOf("/") !== -1) {
            navigate(targetView);
        } else {
            setBasicActive(targetView);
        }
        setShowWarning(false);
    };

    const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

    useEffect(() => {
        setEdited(isSave);
    }, [isSave]);

    const onSubmit = async (data) => {
        let modifiedData = extractModifiedFields(dirtyFields, data);
        if (modifiedData) {
            modifiedData.reqid = 128;
            modifiedData.siteid = JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid;
            modifiedData.vmtype = vmInfo.vmtype;
            modifiedData.vmid = vmInfo.vmid;

            console.log("Modified data for VM settings :::" + JSON.stringify(modifiedData));

            setIsloading(true);
            let saveResponse = await updateSharedVoicemail(modifiedData);
            console.log(`Response of Edit VM :::: ${JSON.stringify(saveResponse)}`);
            let saveResponseMsg = await saveResponse.json();
            console.log("Response of modified data VM :::" + JSON.stringify(saveResponseMsg));
            setTimeout(() => {
                setIsloading(false);
            }, 1000);

            if (saveResponseMsg.status && saveResponseMsg.status == "success") {
                setRerender(true);
                setSuccessMessage(saveResponseMsg.message);
            } else {
                if (saveResponseMsg.message?.errors) {
                    saveResponseMsg.message.errors.forEach((err) => {
                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();
                            fieldElement.scrollIntoView({ behavior: "smooth" });
                        }
                    });
                }
            }
        }
    };

    function extractModifiedFields(dirtyFields, data) {
        const modifiedData = {};

        function recurse(dirtyFields, data, modifiedData) {
            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                        modifiedData[field] = {};
                        recurse(dirtyFields[field], data[field], modifiedData[field]);
                    } else {
                        modifiedData[field] = data[field];
                    }
                }
            }
        }

        recurse(dirtyFields, data, modifiedData);
        return modifiedData;
    }

    function closeSave(e) {
        reset();
    }

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const scrollspyLinks = document.querySelectorAll(".nav-link");
            const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
            const stickyParent = lastLink?.closest(".sticky-top");
            if (stickyParent && lastLink?.classList.contains("active")) {
                lastLink.classList.remove("active");
                for (let i = 0; i < scrollspyLinks.length; i++) {
                    const firstLink = scrollspyLinks[i];
                    const parent = firstLink.closest(".sticky-top");
                    if (parent) {
                        firstLink.classList.add("active");
                        break;
                    }
                }
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <>
            <React.Fragment>
                <>
                    <MainLinks active={2} />
                    <Body
                        tablinks={2}
                        sublink={129}
                        content={
                            <>
                                <section className="mb-3">
                                    <div className="card card-height">
                                        <div className="card-header py-3 px-0">
                                            <h5 className="mb-0 ">
                                                <MDBBreadcrumb>
                                                    <MDBBreadcrumbItem>
                                                        <a
                                                            onClick={(e) => {
                                                                if (isEdited) {
                                                                    setTargetView("/phonenumbers");
                                                                    setShowWarning(true);
                                                                    return;
                                                                }
                                                                navigate("/phonenumbers");
                                                            }}
                                                        >
                                                            <strong>{t("phoneSystem")}</strong>
                                                        </a>
                                                    </MDBBreadcrumbItem>
                                                    <MDBBreadcrumbItem active>
                                                        <a
                                                            onClick={(e) => {
                                                                if (isEdited) {
                                                                    setTargetView("/vmlanding");
                                                                    setShowWarning(true);
                                                                    return;
                                                                }
                                                                navigate("/vmlanding");
                                                            }}
                                                        >
                                                            <strong>{t("vmBox")}</strong>
                                                        </a>
                                                    </MDBBreadcrumbItem>
                                                    <MDBBreadcrumbItem>
                                                        <a href="">
                                                            <strong>{vmName}</strong>
                                                        </a>
                                                    </MDBBreadcrumbItem>
                                                </MDBBreadcrumb>
                                            </h5>
                                        </div>
                                        <div className="card-body px-0">
                                            <div className="pb-2">
                                                <h5 className="fw-600 mt-2 ">{vmName}</h5>
                                                <p className="mt-2 text-secondary">
                                                    Extension: {extension ?? ""}
                                                </p>
                                                <p className="mt-2 text-secondary">
                                                    Pin: {vmPin ? vmPin : "N/A"}
                                                </p>
                                                {assocCallFlows && assocCallFlows?.length > 0 && (
                                                    <h6 className="mt-2">
                                                        <strong className="mt-3 mb-0">
                                                            Associated Call Flow
                                                        </strong>
                                                        <p className="mt-2">
                                                            {assocCallFlows
                                                                ?.map(
                                                                    (obj) =>
                                                                        " " + obj.name + " : " + obj.extension + " ",
                                                                )
                                                                .toString()}
                                                        </p>
                                                    </h6>
                                                )}
                                            </div>

                                            <MDBTabs className="mb-3">
                                                <MDBTabsItem>
                                                    <MDBTabsLink
                                                        onClick={() => handleBasicClick("tab1")}
                                                        active={basicActive === "tab1"}
                                                    >
                                                        Settings
                                                    </MDBTabsLink>
                                                </MDBTabsItem>
                                                <MDBTabsItem>
                                                    <MDBTabsLink
                                                        onClick={() => handleBasicClick("tab2")}
                                                        active={basicActive === "tab2"}
                                                    >
                                                        User
                                                    </MDBTabsLink>
                                                </MDBTabsItem>
                                            </MDBTabs>

                                            <MDBTabsContent>
                                                <MDBTabsPane open={basicActive === "tab1"}>
                                                    <MDBRow>
                                                        <MDBCol size="2" md="2" lg="2" sm="12" className="col-sm-100 pr-0 leftTabs">
                                                            <MDBScrollspy container={containerRef}>
                                                                <MDBScrollspyLink targetRef={section1}>
                                                                    Voicemail
                                                                </MDBScrollspyLink>
                                                            </MDBScrollspy>
                                                        </MDBCol>
                                                        <MDBCol size="12" md="10" sm="12" pr-0 className="col-sm-100 pr-0 leftTabContent">
                                                            <div
                                                                id="element"
                                                                ref={containerRef}
                                                                className="scrollspy-example"
                                                            >
                                                                <section ref={section1} id="section-1">
                                                                    <FormProvider {...methods}>
                                                                        <VMSettingsMain
                                                                            vmCode={vmInfo.id}
                                                                            vmid = {vmInfo.vmid}
                                                                            greetingsInfo={greetingsInfo}
                                                                        />
                                                                    </FormProvider>
                                                                </section>
                                                            </div>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    {isSave && (
                                                        <SaveChanges
                                                            onClose={closeSave}
                                                            isdirtyFields={isSave}
                                                            onSave={(e) => {
                                                                e.preventDefault();
                                                                handleSubmit(onSubmit)();
                                                            }}
                                                        />
                                                    )}
                                                </MDBTabsPane>
                                                <MDBTabsPane open={basicActive === "tab2"}>
                                                    <div className="vmBoxUserDatatable">
                                                        {basicActive === "tab2" && (
                                                            <VMSettingsUsers vmid={vmInfo.vmid} />
                                                        )}
                                                    </div>
                                                </MDBTabsPane>
                                            </MDBTabsContent>
                                        </div>
                                    </div>
                                </section>
                            </>
                        }
                    />
                </>
                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Remove
                </Tooltip>

                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner
                                    size="sm"
                                    role="status"
                                    tag="span"
                                    className="me-2"
                                />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}

                {successMessage && (
                    <>
                        <TopSuccess>
                            <TopMessage successMessage={successMessage} />
                        </TopSuccess>
                    </>
                )}

                {showWarning && (
                    <EditWarning
                        warningToggle={warningToggle}
                        setShowWarning={setShowWarning}
                        onOk={handleOk}
                    />
                )}
            </React.Fragment>
        </>
    );
}

export default VMSettings;
